module.exports = __webpack_public_path__ + "static/crea-402475445169ea4fc4ca1e2c1522467c.jpg";